import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AuthInterceptor, HttpLoaderFactory, RestApiService } from '@macq/m3-front-lib-core';
import { AppComponent } from './app/app.component';
import { AppRoutes } from './app/app.routes';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { importProvidersFrom } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

bootstrapApplication(AppComponent, {
    providers: [
        { provide: 'environment', useValue: environment },
        provideHttpClient(withInterceptors([new AuthInterceptor().intercept])),
        provideAnimations(),
        provideRouter(AppRoutes, withComponentInputBinding()),
        importProvidersFrom(
            CommonModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: HttpLoaderFactory,
                    deps: [RestApiService]
                }
            })
        )
    ]
    // eslint-disable-next-line no-console
}).catch((err) => console.error(err));
